import React from "react"
import Img from 'gatsby-image'
import PortableText from "@sanity/block-content-to-react"

import galleryImg from "../../images/about/gallery.jpg"

import { Wrapper } from "./style"

const About = props => {
  return (
    <Wrapper>
      <div className="about_me">
        <Img fluid={props.profile_picture.asset.fluid} alt={props.name}/>
        <div className="description">
          <h2>{props.title}</h2>
          <PortableText blocks={props.details} className="post_content" />
        </div>
      </div>
      <div className="gallery_container">
        <h2>Gallery</h2>
        <div className="gallery">
          <img src={galleryImg} alt="gallery" />
          <img src={galleryImg} alt="gallery" />
          <img src={galleryImg} alt="gallery" />
          <img src={galleryImg} alt="gallery" />
          <img src={galleryImg} alt="gallery" />
          <img src={galleryImg} alt="gallery" />
        </div>
      </div>
    </Wrapper>
  )
}

export default About
